import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EmailTemplatestable from "../../components/EmailTemplates/EmailTemplatestable";
import EmailTemplatesV2 from "../../components/EmailTemplates/EmailTemplatesV2";

const EmailTemplatesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
             
                <Breadcrumb title="Email Templates" />
                {/* <EmailTemplatestable/> */}

                <EmailTemplatestable/>


            </MasterLayout>
        </>
    );
};

export default EmailTemplatesPage;
